import { defineStore } from 'pinia';

export const useLoadingStore = defineStore('loading', {
    state: () => {
        return {
            loadingStack: [],
            state: -1,
            loading: 0,
        }
    },
    actions: {
        startLoading(state) {
            if (!state) state = 0;
            this.loadingStack.push(state);
            if (state != -1) {
                this.loading++;
                this.state = state;
            }
        },
        endLoading() {
            const lastState = this.loadingStack.pop();
            if (lastState != -1) this.loading--;
            let state = -1;
            for (let i = this.loadingStack.length - 1; i >= 0; i--) {
                const s = this.loadingStack[i];
                if (s != -1) {
                    state = s;
                    break;
                }
            }
            this.state = state;
        }
    }
})